export default {
  computed: {
    projectName() {
      if (!this.projectId || !this.projects.length) {
        return 'All Projects'
      } else {
        var obj = this.getObjectFromArray(this.projects, 'id', this.projectId)
        return obj.name
      }
    },
    siteName() {
      if (!this.siteId || !this.sites.length) {
        return 'All Sites'
      } else {
        var obj = this.getObjectFromArray(this.sites, 'id', this.siteId)
        return obj.name
      }
    },
    selectedUserName() {
      if (!this.selectedUserId || !this.users.length) {
        return 'All Users'
      } else {
        var obj = this.getObjectFromArray(this.users, 'id', this.selectedUserId)
        var nameArray = obj.name.split(' ')
        return nameArray[0];
      }
    },
    contractorName() {
      if (!this.contractorId || !this.contractors.length) {
        return 'All Contractors'
      } else {
        var obj = this.getObjectFromArray(this.contractors, 'id', this.contractorId)
        return obj.name
      }
    },
    vehicleName() {
      if (!this.vehicleId || !this.vehicles.length) {
        return 'All Vehicles'
      } else {
        var obj = this.getObjectFromArray(this.vehicles, 'id', this.vehicleId)
        return obj.name
      }
    },
    driverName() {
      if (!this.driverId || !this.drivers.length) {
        return 'All Drivers'
      } else {
        var obj = this.getObjectFromArray(this.drivers, 'id', this.driverId)
        return obj.name
      }
    }
  }
}